import cx from 'classnames';
import type { VoidFunctionComponent } from 'react';

import { Icon, icons } from '../../../generic';

import styles from './BranchesDropdown.module.less';

export type Tab = 'branches' | 'tags';

type Props = {
  selectedTab: Tab;
  onSelectTab: (tab: Tab) => void;
  shouldShowTags?: boolean;
};

/**
 * Displays the tabs for selecting between viewing branches and tags
 * within the BranchesDropdown menu.
 */
const BranchesDropdownTabs: VoidFunctionComponent<Props> = ({
  selectedTab,
  onSelectTab,
  shouldShowTags,
}) => {
  return (
    <div className={styles.dropdownMenuTabs}>
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <span
        onClick={() => onSelectTab('branches')}
        className={cx(styles.dropdownMenuTab, { [styles.dropdownMenuTabSelected]: selectedTab === 'branches' })}
      >
        <Icon icon={icons.codeBranch} />
        Branches
      </span>
      {shouldShowTags && (
        // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
        <span
          onClick={() => onSelectTab('tags')}
          className={cx(styles.dropdownMenuTab, { [styles.dropdownMenuTabSelected]: selectedTab === 'tags' })}
        >
          <Icon icon={icons.tags} />
          Tags
        </span>
      )}
    </div>
  );
};

export default BranchesDropdownTabs;
